// src/theme.js
const themeColors = {
    teal: "#007F7E",
    darkTeal: "#005F5E",
    lightGray: "#F8F9FA",
};

export default themeColors;
